export var BrandResponsibility = function BrandResponsibility(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return brandResponsibilityBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return brandResponsibilityBuilder(strictLocalize).getDescription();
    }
  };
};
var brandResponsibilityBuilder = function brandResponsibilityBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "Dg58Ac",
        defaultMessage: [{
          "type": 0,
          "value": "Internationale verzendregelgeving"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "hjwQzs",
        defaultMessage: [{
          "type": 0,
          "value": "Alle merken die op Faire verkopen, zijn verantwoordelijk voor het naleven van alle wetten, regels en voorschriften in alle landen of regio’s waarin ze hun producten via het platform verkopen."
        }]
      }), strictLocalize({
        id: "ujgpuX",
        defaultMessage: [{
          "type": 0,
          "value": "Dit is inclusief maar niet beperkt tot: productveiligheid, labelvereisten, testen, waarschuwingen, auteursrecht, import-/exportvoorschriften en andere wettelijke vereisten voor consumentenbescherming."
        }]
      }), strictLocalize({
        id: "DAIwfn",
        defaultMessage: [{
          "type": 0,
          "value": "Raadpleeg een douane-expediteur of juridisch adviseur om te bepalen of je producten in andere landen of regio’s kunnen worden verkocht."
        }]
      })];
    }
  };
};